export enum EmptyCollectionStates {
  NoRecords = 'NoRecords',
  NoResults = 'NoResults',
}
